import React, { useEffect, useState } from 'react'
import './AdminTeamList.css'
import { NavLink } from 'react-router-dom'
import AdminNavigation from './AdminNavigation'

const AdminHowTo = () => {
	const [error, setError] = useState()

	const errorHandler = () => {
		setError(null)
	}

	return (
		<React.Fragment>
			<AdminNavigation />
			<div>
				<div className='Teams' style={{ marginBottom: '4rem' }}>
					<AdminNavigation />
					<h1>How-To Videos</h1>
					<p style={{ textAlign: 'center' }}>
						The videos on this page should help you get started with setting up
						and using your site.
					</p>
					<p style={{ textAlign: 'center' }}>
						For any additional questions or concerns, you can always email me at
						matt@shireystatsandstandings.com
					</p>
					<p style={{ textAlign: 'center' }}>
						Or, feel free to reach me at 724-875-8661.
					</p>
					<p style={{ textAlign: 'center' }}>Thank you!</p>
				</div>
				<div style={{ marginBottom: '10rem' }}>
					{/* //
        //
        //   Video One
        //
        // */}
					<div style={{ display: '-webkit-box' }}>
						<a
							href='https://www.youtube.com/watch?v=JM360HPpUQI'
							target='_blank'
							rel='noreferror'
							className='infoLink'
						>
							Video 1: Create a New Tournament (3:51)
						</a>
					</div>
					<h5 style={{ marginBottom: '2.5rem' }}>
						Set up a new Tournament, create divisions and teams, archive any old
						tournaments.
					</h5>
					{/* //
        //
        //   Video Two
        //
        // */}
					<div style={{ display: '-webkit-box' }}>
						<a
							href='https://www.youtube.com/watch?v=KBMk9cIrESU'
							target='_blank'
							rel='noreferror'
							className='infoLink'
						>
							Video 2: Uploading Teams (3:45)
						</a>
					</div>
					<h5 style={{ marginBottom: '2.5rem' }}>
						Upload teams from the Spreadsheet
					</h5>
					{/* //
        //
        //   Video Three
        //
        // */}
					<div style={{ display: '-webkit-box' }}>
						<a
							href='https://www.youtube.com/watch?v=VoYV4mZmDE4'
							target='_blank'
							rel='noreferror'
							className='infoLink'
						>
							Video 3: Adding Games and Events
						</a>
					</div>
					<h5 style={{ marginBottom: '2.5rem' }}>
						Add games, add events, edit games or events, view the schedule.
					</h5>
					{/* //
        //
        //   Video Four
        //
        // */}
					<div style={{ display: '-webkit-box' }}>
						<a
							href='https://www.youtube.com/watch?v=6Gjvur7SOIM'
							target='_blank'
							rel='noreferror'
							className='infoLink'
							style={{ display: '-webkit-box' }}
						>
							Video 4: Entering Game Results
						</a>
					</div>
					<h5 style={{ marginBottom: '2.5rem' }}>
						Enter game results, including score, player stats, goalie stats, and
						penalties.
					</h5>
					{/* //
        //
        //   Video Five
        //
        // */}
					<div style={{ display: '-webkit-box' }}>
						<a
							href='https://www.youtube.com/watch?v=uUeSIFwbEus'
							target='_blank'
							rel='noreferror'
							className='infoLink'
							style={{ display: '-webkit-box' }}
						>
							Video 5: Archiving Teams, View Player History
						</a>
					</div>
					<h5 style={{ marginBottom: '2.5rem' }}>
						What does archiving mean, and why do we archive old teams.
					</h5>
					{/* //
        //
        //   Video Six
        //
        // */}
					<div style={{ display: '-webkit-box' }}>
						<a
							href='https://www.youtube.com/watch?v=3V2kgr5r7xI'
							target='_blank'
							rel='noreferror'
							className='infoLink'
							style={{ display: '-webkit-box' }}
						>
							Video 6: Add a Player's Profile Picture (1:32)
						</a>
					</div>
					<h5>Add a player profile picture for their personal stats page.</h5>
				</div>
			</div>
		</React.Fragment>
	)
}

export default AdminHowTo
